export const ALERT_TYPES = Object.freeze({
  validate_joined_associate: {
    title: 'Validate Associate',
    color: '#6b7280'
  },
  associate_joined: {
    title: 'Associate Joined',
    color: '#10b981'
  },
  associate_left: {
    title: 'Associate Left',
    color: '#10b981'
  },
  join_project_request: {
    title: 'Join Request',
    color: '#f59e0b'
  },
  project_summary: {
    title: 'Company Summary',
    color: '#f59e0b'
  },
  sequence_completed: {
    title: 'In-Services Completed',
    color: '#f59e0b'
  },
  unauthorized_authorizations: {
    title: 'Unreviewed Violations',
    color: '#f59e0b'
  },
  document_signed: {
    title: 'Document Signed',
    color: '#ef4444'
  },
  associate_document_expired: {
    title: 'Associate document expired',
    color: '#ef4444'
  },
  associate_inactive: {
    title: 'Associate Disabled',
    color: '#3b82f6'
  },
  associate_resigned: {
    title: 'Associate Resigned',
    color: '#10b981'
  },
  project_document_update: {
    title: 'Project Document Update',
    color: '#10b981'
  },
  info: {
    title: 'Info',
    color: '#3b82f6'
  },
  review_time_off: {
    title: 'Review Time Off',
    color: '#3b82f6'
  }
})

export const SEVERITY_TYPES = Object.freeze({
  normal: {
    title: 'Info',
    color: '#3b82f6',
    description: 'Normal alerts do not affect workflow'
  },
  warning: {
    title: 'Warning',
    color: '#f59e0b',
    description: 'Warning alerts notify associates each login'
  },
  forbid_work: {
    title: 'Critical',
    color: '#ef4444',
    description: "Associates can't start work until the document is signed."
  }
})

export const NOTIFICATION_SOURCE = [
  { name: 'Alert/PUSH', id: 'with_alert' },
  { name: 'SMS', id: 'with_sms' },
  { name: 'Email', id: 'with_email' },
  { name: 'Work Notice', id: 'with_work_notice' }
]
